import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class TooLargeDefaultDiscountValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.client.validation.default-discount.too-large');
    }
}
